export default () => {
  return window.location.hash.split('#/').filter(path => path)
}
